export default __webpack_public_path__ + "static/COVID-19_Home_Learning_Policy-3955dccb4b4f07e75d323d657011ec33.pdf";